export default __webpack_public_path__ + "static/contacto-19e3da2fffaca758f22892415e047eac.png";